import React from "react";

export const SEO = ({
  meta,
  handle,
  path,
  additionalTitle,
  additionalDescription,
}) => {
  if (!meta) return <></>;
  const { noIndex, isCanonical, canonical, noFollow, lang, type } = meta;

  const title = meta.title ? meta.title : additionalTitle;
  const description = meta.description
    ? meta.description
    : additionalDescription;

  const image = meta?.image?.src;

  const {
    article: { publishedAt, section, tag: articleTag, articleAuthor } = {},
    product: { priceAmount, priceCurrency } = {},
    video: { duration, height, width } = {},
    book: { author, isbn, releaseDate, tag: bookTag } = {},
  } = meta;

  const typeMetaTags = {
    website: [],
    article: [
      { property: "article:published_time", content: { publishedAt } },
      { property: "article:section", content: { section } },
      { property: "article:tag", content: { articleTag } },
    ],
    product: [
      { property: "product:price:amount", content: { priceAmount } },
      { property: "product:price:currency", content: { priceCurrency } },
    ],
    video: [
      { property: "video:duration", content: { duration } },
      { property: "video:height", content: { height } },
      { property: "video:width", content: { width } },
    ],
    book: [
      { property: "book:author", content: { author } },
      { property: "book:isbn", content: { isbn } },
      { property: "book:release_date", content: { releaseDate } },
      { property: "book:tag", content: { bookTag } },
    ],
    profile: [],
  };

  // Look up the appropriate meta tags based on the `og:type` value
  const metaTagsByType = typeMetaTags[type] || [];

  function getRobotsContent(noIndex, noFollow) {
    if (noIndex && noFollow) {
      return "noindex, nofollow";
    } else if (noIndex) {
      return "noindex, follow";
    } else if (noFollow) {
      return "index, nofollow";
    } else {
      return "index, follow";
    }
  }

  const CanonicalComponent = () => {
    if (!path && handle === "/") {
      return <link rel="canonical" href={`${SITE_URL}`} />;
    } else if (!path && handle !== "/") {
      return isCanonical === false ? (
        <link rel="canonical" href={`${SITE_URL}/${canonical}`} />
      ) : (
        <link rel="canonical" href={`${SITE_URL}/${handle}`} />
      );
    } else if (path) {
      return isCanonical === false ? (
        <link rel="canonical" href={`${SITE_URL}/${path}/${canonical}`} />
      ) : (
        <link rel="canonical" href={`${SITE_URL}/${path}/${handle}`} />
      );
    }
  };

  //Use this from .env
  const SITE_URL = "oldgoldracing.com";

  return (
    <>
      <html rel="alternate" href={SITE_URL} lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description}></meta>
      {/* {isCanonical ?
        <link rel="canonical" href={`${SITE_URL}/${handle}`} /> :
        <link rel="canonical" href={`${SITE_URL}/${canonical}`} />
      } */}
      <CanonicalComponent />
      <meta name="robots" content={getRobotsContent(noIndex, noFollow)} />

      <meta property="og:site_name" content="Old Gold Racing"></meta>
      <meta property="og:type" content={type}></meta>
      <meta property="og:url" content={`${SITE_URL}/${handle}`}></meta>
      <meta property="og:title" content={title}></meta>
      <meta
        name="description"
        property="og:description"
        content={description}
      ></meta>
      <meta property="og:image" content={image}></meta>
      <meta property="og:locale" content={lang} />

      {metaTagsByType.map((meta, index) => (
        <meta
          key={index}
          property={meta.property}
          content={meta.content[Object.keys(meta.content)[0]]}
        />
      ))}

      {/* Schema.org */}

      {type === "article" && (
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "headline": "${title}",
            "image": [
              "${image}"
             ],
            "datePublished": "${publishedAt}",
            "dateModified": "${publishedAt}",
            "author": [{
              "@type": "Person",
              "name": "${articleAuthor}"
            }]
          }
        `}
        </script>
      )}

      {/* Twitter Card*/}
      <meta name="twitter:card" content="summary_large_image"></meta>
      <meta name="twitter:title" content={title}></meta>
      <meta name="twitter:description" content={description}></meta>
      <meta name="twitter:image" content={image}></meta>
      <meta property="twitter:domain" content={SITE_URL}></meta>
      <meta property="twitter:url" content={SITE_URL}></meta>
    </>
  );
};
